export const mediaInFolders = state => {
  return state.api.folders.media;
};
